export default "__VITE_ASSET__CXvpdRkD__"